export default () => {
  const $content1 = $('.js-frontPage__primaryImageWrapper')
  const $content2 = $('.js-clubBanner__box')

  if (!$content1.length || !$content2.length) return

  const $window = $(window)

  function drawLine() {
    const scrollPosition = window.scrollY
    const content1_position = $content1[0].getBoundingClientRect().top + $content1[0].scrollHeight + scrollPosition;
    const content2_position = $content2[0].getBoundingClientRect().top + scrollPosition;

    const offset = 20
    const diff = ( content2_position - content1_position ) + offset
    let $line = $('.l-contentLine')
    if ( !$line.length ) {
      $content1.append('<div class="l-contentLine"></div>')
      $line = $('.l-contentLine')
    }
    $line.css({
      'height': `${diff}px`,
    })
  }

  $window.on('resize', drawLine)
  $window.on('scroll', drawLine)

  drawLine()

}